module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "the-aberbryncraig-telegraph"
    }
  }, [_c('h1', [_vm._v("The Aberbryncraig Telegraph")]), _vm._v(" "), _c('p', [_vm._v("The Aberbryncraig Telegraph works in many ways, but the quickest way is if news is told to children at the "), _c('em', [_vm._v("ysgol")]), _vm._v(" (school). The children pass news from one to the other with terrifying speed, then they tell their parents who tell their friends by telephone, text, over the garden fence, in the pub, at coffee mornings and in one of the cafés (overhearing is quite useful here) and by email (yes modern technology has arrived in the village, just about and not always successfully, as we will see). By these means within a very short time the Aberbryncraig Telegraph has made sure everyone knows any news there is to know.")]), _vm._v(" "), _c('p', [_vm._v("It’s good.")]), _vm._v(" "), _c('p', [_vm._v("Mrs Mopalot has sometimes creatively used the telegraph to help her with her investigations and to provide solutions to the problems raised.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8ebb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0